import React, { useState } from "react";
import {FormatedPrice} from '@gull'
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios'
import swal from "sweetalert2";

const LineArticleRetour = (props) =>{
    const t = useTranslate();
    const [loadRetour,setLoadRetour]=useState(false)
    const idsLocalStorage=localStorage.getItem("pos").split(',')
    
    const [returnQuantity,setReturnQuantity]=useState(props.value.to_return_quantity)

    const handleClick = async (ticketRetourId,articleRetourId,ticketDetailRetourId,toUpDate,to_return_quantity,combo) =>{
        setLoadRetour(true)
        let data={
            retour_id:ticketRetourId,
            article_retour_id:articleRetourId,
            ticket_detail_retour_id:ticketDetailRetourId,
            retour_quantity:to_return_quantity,
            combo:combo
        }
        if(props.cookies.current_ticket){
            data['id']=props.cookies.current_ticket
        }
        if(props.cashierId){
            data['rh_id']=props.cashierId
        }
        if(props.clientId){
            data['client_id']=props.clientId
        }


        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/ticket/construction/"+props.posid+"/"+idsLocalStorage[1]+"/"+idsLocalStorage[0], data
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }else{   
                props.setCurrentTicket(response.data.data)
                if(!props.cookies.current_ticket){
                    props.setCookie("current_ticket",response.data.data.id,{ path: "/", expires: props.expire_date })
                }

                //mise à jour de la liste des articles du ticket retourné
                let toUpdateLine = props.ticketRetourDetail[toUpDate]
                let unitPrice = +toUpdateLine.prix_remise / +toUpdateLine.quantity

                toUpdateLine.to_return_prix_remise = +toUpdateLine.to_return_prix_remise - +(unitPrice*returnQuantity)
                toUpdateLine.to_return_quantity = +toUpdateLine.to_return_quantity - returnQuantity
                props.setTicketRetourDetail({...props.ticketRetourDetail})
                setLoadRetour(false)

                let articleAfficheur = response.data.data.ticket_detail.sort((a,b) => b.id - a.id).find(value=>value.article_retour_id == articleRetourId)

                if(props.peripheriqueParam && props.peripheriqueParam.afficheur && props.peripheriqueParam.afficheur.model=='aures_2_l'){
                    props.affichageClient(articleAfficheur.article_retour.name,(articleAfficheur.combo) ? articleAfficheur.prix_combo : articleAfficheur.prix_remise, articleAfficheur.quantity,0,props.devise,t,props.peripheriqueParam)
                    //le 0 sur la variable 'raison' est passé pour définir que les infos ne concerne pas le total
                }
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setLoadRetour(false)
    }

    const handleChange = (e) => {
        if (props.value.combo) setReturnQuantity(Math.round(Number(e.target.value)))
        else setReturnQuantity(Number(e.target.value))
    }

    return(
        <tr
            className={props.style}
        >
            <td>{props.value.article.name}</td>
            <td >{props.value.remise}</td>
            <td >{props.value.to_return_quantity}</td>
            <td>
                <input
                    type="number"
                    min="0"
                    max={props.value.to_return_quantity}
                    value={returnQuantity}
                    onChange={(e) => handleChange(e)}
                    className="form-control"
                />
            </td>
            <td>
                <span>{<FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.value.to_return_prix_remise} />}</span>&nbsp;
            </td>
            <td className="text-end">
                <button
                    type="button"
                    className="btn btn-primary"
                    disabled={loadRetour || returnQuantity <= 0 || returnQuantity > props.value.to_return_quantity}
                    onClick={() => handleClick(props.value.ticket_id, props.value.article_id, props.value.id, props.lineId, returnQuantity, props.value.combo)}
                >
                    {loadRetour ? <span className="spinner-border spinner-border-sm "></span> : t('retour')}
                </button>
            </td>
        </tr>
    )
}

export default LineArticleRetour;